<template>
  <!-- // loading -->
  <div v-if="isLoading"   class="loading-process">
    <div class="loading"></div>
    <div class="loading-text">loading</div>

  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'Loading',
    components: {},
    data: () => {
        return {};
    },
    computed: {
        ...mapState({
            isLoading: state => state.facemapping.isLoading
        })
    },
    beforeCreate() {},
    created() {},
    mounted() {},
    beforeDestroy() {},
    methods: {
        ...mapActions([])
    }
};
</script>
